import React, {CSSProperties, useEffect, useState} from 'react';
import classNames from 'classnames';

export interface WaitingDialogItemProps {
  progress: number;
  animate?: boolean;
}

const ProgressBar = ({progress, animate}: WaitingDialogItemProps) => {
  const [progressPercent, setProgressPercent] = useState<number>(0);
  const progressBarClasses = classNames(
    'flex',
    'relative',
    'bg-themeTextColour20',
    'rounded-themeCornerSize',
    'overflow-hidden',
    'h-sm',
    'w-full',
    'before:bg-themeAccentColour',
    'before:absolute',
    'before:h-full',
    'before:transition-all',
    animate ? 'before:duration-[10s]' : 'before:duration-[0s]',
    'before:w-[calc(var(--progressPercent)*1%)]'
  );

  // Set the progress bar percentage via a use effect to ensure CSS sees a change from zero to the first percentage.
  useEffect(() => {
    setProgressPercent(progress);
  }, [progress]);

  return (
    <div
      className={progressBarClasses}
      style={{'--progressPercent': progressPercent} as CSSProperties}
    ></div>
  );
};

export default ProgressBar;
